import React from "react";
import "./style.css";
import { GetObjectKey } from "../../../../helpers/getObjectKeyFromValue";
import ExamCategoryType from "../../../../enums/ExamCategoryType";

const ProductList = ({ list, selected, onSelect }) => {
  return (
    <div className="product-list-container">
      <h4 className="section-title">Ürün Seçimi</h4>

      {list && list.length > 0 ? (
        <div className="product-group-list">
          {list.map(function (group, gIndex) {
            return (
              <div key={gIndex} className="product-group">
                <h5 className="product-group-title">{group.ProductTag}</h5>

                <div className="product-list">
                  {group.Products && group.Products.length > 0 ? (
                    group.Products.map(function (p, index) {
                      return (
                        <label
                          key={index}
                          className={
                            selected && selected.Id === p.Id
                              ? "product-item active"
                              : "product-item"
                          }
                        >
                          <input
                            type="radio"
                            name="product"
                            checked={selected && selected.Id === p.Id}
                            onChange={function () {
                              onSelect(p);
                            }}
                          />
                          <div className="product-info">
                            <div className="product-header">
                              <img
                                src={p.ImageUrl}
                                alt={p.ProductName}
                                className="product-thumb"
                              />
                              <div>
                                <strong>{p.ProductName}-{GetObjectKey(p.ExamCategoryId,ExamCategoryType)}</strong>
                                <p className="product-title">{p.Title}</p>
                              </div>
                            </div>

                            <p className="product-description">
                              {p.DescriptionOne}
                            </p>
                            <small className="product-price">
                              {(p.Price / 100).toLocaleString("tr-TR")} ₺
                            </small>
                          </div>
                        </label>
                      );
                    })
                  ) : (
                    <p className="no-products">Bu grupta ürün bulunamadı.</p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <p className="no-products">Henüz ürün bulunamadı.</p>
      )}
    </div>
  );
};

export default ProductList;
